module.exports = __webpack_public_path__ + "img/fsr-floor-space-ratio.41e24831.svg";